// extracted by mini-css-extract-plugin
export default {"cls1":"g6NjrHbjHILeUozNPsWe","cls2":"X3E2XoozmuIo_yH7fEvj g6NjrHbjHILeUozNPsWe"};